import * as React from 'react';
import FormContainer from '../../components/Form/FormContainer';
import { duplicateLogin as Language } from '../../Util/language.json';

// 중복로그인
const DuplicateLogin = () => (
  <FormContainer caption={Language.caption}>
    <div className="msg">
      <div className="caption">{Language.message}</div>
    </div>
    <a className="link color-secondary" href="/">
      {Language.home}
    </a>
  </FormContainer>
);

export default DuplicateLogin;
